<template>
	<el-row>
		<div style="padding:20px 20px;border:1px solid #ebeef5;margin-top:20px;">
			<i class="el-icon-tickets" style="font-size:18px;margin-right:5px" />
			<span>{{ oneInfo.namePath }}</span>
		</div>
		<h2>公共素材</h2>
		<el-col :span="24">
			<div class="flex">
				<block v-for="(item, index) in list" :key="index">
					<el-card shadow="hover" v-if="item.type == 'COMMUNITY'" @click.native="toThree(item)">
						<el-image style="width: 100px;height:100px;"
							src="http://img.xinian727.cn/xnmall3/images/wenjian.png" />
						<div class="name">{{ item.name }}</div>
						<div class="btnBox">
							<el-button type="primary" icon="el-icon-edit" circle size="mini"
								@click.stop="open(1, item)">
							</el-button>
							<el-button type="danger" icon="el-icon-delete" circle size="mini"
								@click.stop="remove(item)">
							</el-button>
						</div>
					</el-card>
				</block>
				<el-card shadow="hover">
					<div class="addBox" @click="open(1)">+</div>
				</el-card>
			</div>
		</el-col>
		<el-col>
			<el-divider></el-divider>
		</el-col>
		<h2>定向素材</h2>
		<el-col :span="24">
			<div class="flex">
				<block v-for="(item, index) in list" :key="index">
					<el-card shadow="hover" v-if="item.type == 'TARGETING'" @click.native="toThree(item)">
						<el-image style="width: 100px;height:100px;"
							src="http://img.xinian727.cn/xnmall3/images/wenjian.png" />
						<div class="name">{{ item.name }}</div>
						<div class="btnBox">
							<el-button type="primary" icon="el-icon-edit" circle size="mini"
								@click.stop="open(2, item)">
							</el-button>
							<el-button type="danger" icon="el-icon-delete" circle size="mini"
								@click.stop="remove(item)">
							</el-button>
						</div>
					</el-card>
				</block>
				<el-card shadow="hover">
					<div class="addBox" @click="open(2)">+</div>
				</el-card>
			</div>
		</el-col>

		<el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
			<el-form :model="form" ref="form" :rules="rules" label-width="80px" label-position="right">
				<el-form-item label="文件名" prop="name">
					<el-input v-model="form.name" placeholder="请输入文件名"></el-input>
				</el-form-item>
				<el-form-item label="关联商品id" v-if="type == 2">
					<el-input v-model="form.goodsIds" placeholder="请输入关联商品id"></el-input>
					<span>输入多个商品id请用<span style="color: red;">英文逗号</span>隔开</span>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submit">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				oneInfo: {},
				title: "",
				type: null,
				dialogVisible: false,
				form: {
					id: undefined,
					name: "",
					type: 'COMMUNITY',
					sort: 1,
					goodsIds: undefined
				},
				rules: {
					name: [{
						required: true,
						message: "请输入一级文件夹名",
						trigger: "change"
					}],
				},
				list: [],
			};
		},
		created() {
			this.oneInfo = this.$route.query
			console.log(this.oneInfo);
			this.loadData()
		},
		methods: {
			loadData() {
				this.$http.get('/api/material/categories/' + this.oneInfo.id, {}).then(res => {
					console.info("loadData", res)
					this.list = res.data ? res.data.children : []
				})
			},
			toThree(item) {
				console.log(item);
				let routeData = this.$router.resolve({
					path: "/mat_class3",
					query: item,
				});
				window.open(routeData.href, '_blank');
			},
			remove(row) {
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$http.delete(
						'/api/material/categories/' + row.id, {}
					).then(res => {
						console.info("sumbit", res)
						if (res.status == 500) {
							console.info("系统异常")
						}
						if (res.status == 202) {
							console.info("存在子节点,不允许被删除")
						}
						this.loadData();
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				})
			},
			open(num, row) {
				console.log(num, row);
				this.dialogVisible = true;
				this.type = num
				if (num == 1) {
					if (row) {
						this.title = "公共素材--文件夹编辑"
						this.form = {
							type: 'COMMUNITY',
							id: row.id,
							name: row.name,
							sort: 1,
						};
					} else {
						this.title = "公共素材--文件夹创建"
						this.form = {
							id: undefined,
							name: undefined,
							type: 'COMMUNITY',
							sort: 1
						}
					}
				} else {
					if (row) {
						this.getProductid(row.id)
						this.title = "定向素材--文件夹编辑"
						this.form.type = 'TARGETING'
						this.form.id = row.id
						this.form.name = row.name
						this.form.sort = 1
						console.log(this.form);
					} else {
						this.title = "定向素材--文件夹创建"
						this.form = {
							id: undefined,
							name: undefined,
							type: 'TARGETING',
							sort: 1
						}
					}
				}
			},
			submit() {
				console.log(this.form.type);
				if (this.form.id) {
					this.edit()
					this.edit2()
					this.dialogVisible = false;
				} else {
					this.save()
					this.dialogVisible = false;
				}
			},
			//获取商品id
			getProductid(id) {
				let url = '/api/material/categories/goods/goodsId/list?categoryId=' + id
				this.$http.get(url, {}).then(res => {
					// console.info("商品id", res.data)
					this.form.goodsIds = res.data.join(',')
				})
			},
			save() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						let url = '/api/material/categories/' + this.oneInfo.id + '/children'
						if (this.form.type == 'TARGETING') {
							let goods = []
							if (this.form.goodsIds) {
								this.form.goodsIds.split(',').map(i => goods.push({
									goodsId: i
								}))
							}
							this.form.goods = goods
							url = '/api/material/categories/goods/' + this.oneInfo.id
						}
						this.$http.post(url, this.form).then(res => {
							console.info("sumbit", res)
							if (res.status == 500) {
								console.info("系统异常")
							}
							if (res.data == "请先添加父类目") {
								console.info('父类目不存在')
							} else {
								this.loadData();
							}
						})
						this.dialogVisible = true;
					}
				});
			},
			edit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.$http.put('/api/material/categories/' + this.form.id + '/name', {
							name: this.form.name
						}).then(res => {
							console.info("sumbit", res)
							if (res.status == 500) {
								console.info("系统异常")
							}
							if (res.data == "请先添加父类目") {
								console.info('父类目不存在')
							} else {
								this.loadData();
							}
						})
						this.dialogVisible = false;
					}
				});
			},
			edit2() {
				// todo 修改的时候如果是带有商品的目录。那么需要分辨请求修改类目名字和修改关联商品接口
				// url = '/api/material/categories/goods/'+当前目录id          put方式    和添加分类关联商品提交的数据格式一致
				let goods = []
				if (this.form.goodsIds) {
					this.form.goodsIds.split(',').map(i => goods.push({
						goodsId: i
					}))
				}
				this.form.goods = goods
				console.log(this.form);
				// return false
				this.$http.put('/api/material/categories/goods/' + this.form.id, this.form).then(res => {
					if (res.status == 500) {
						console.info("系统异常")
					}
					if (res.data == "请先添加父类目") {
						console.info('父类目不存在')
					} else {
						this.loadData();
					}
				})
				this.dialogVisible = false;
			},

		},
	};
</script>

<style scoped>
	::v-deep .el-card__body {
		padding: 0;
	}

	::v-deep .el-card {
		width: 100px;
		height: 160px;
		margin: 10px;
	}

	.btnBox {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.flex {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	.addBox {
		font-size: 24px;
		height: 160px;
		line-height: 160px;
		text-align: center;
	}

	.name {
		width: 100%;
		text-align: center;
		margin: -10px auto 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}
</style>
